import { Navigate } from "react-router-dom";
import Home from "../pages/home/Home";
import Services from "../pages/service/Services";
import Blog from "../pages/blog/Blog";
import CheckOut from "../pages/checkout/CheckOut";
import TermsAndConditions from "../pages/termsandconditions/TermsAndConditions";
import PrivacyAndPolicy from "../pages/privacyandpolicy/PrivacyAndPolicy";
import AddressPage from "../pages/addressPage/AddressPage";
import OrderFlow from "../pages/orderFlow/OrderFlow";
import OrderList from "../pages/orderList/OrderList";
import SettingPage from "../pages/setting/SettingPage";
import AddRemoveUpdataAddress from "../pages/addressPage/AddRemoveUpdataAddress";
import NotFound from "../pages/notFound/NotFound";
import OrderDetail from "../pages/orderDetail/OrderDetail";
import ProtectedRoute from "../pages/ProtectedRoute/ProtectedRoute";

import Contact from "../pages/contact/Contact";
import Cart1 from "../pages/cart/Cart1";
import Packages from "../pages/Packages/Packages";
import HelpSection from "../pages/helpCenter/HelpSection";
import CancellationPolicy from "../pages/cancellationPolicy/CancellationPolicy";
import ReviewPage from "../pages/ReviewPage/ReviewPage";
import LegalTranslation from "../pages/LegalTranslation/LegalTranslation";
import NewPayment from "../pages/payment/NewPayment";
import LegalTranslationDetail from "../pages/LegalTranslation/LegalTranslationDetail/LegalTranslationDetail";
import BlogDetails from "../pages/blog/blogDetails/BlogDetails";
import AfterGetQuote from "../components/aftergetquotemodel/AfterGetQuote";
import Booking from "../pages/orderFlow/Booking";
import BookingDetail from "../components/bookingdetail/BookingDetail";
import MarriageServices from "../pages/alAdheed/marriageServices/MarriageServices";
import PesrsonalCases from "../pages/alAdheed/personalCases/PesrsonalCases";
import Aladheed from "../pages/alAdheed/Aladheed";
import CaseService from "../pages/alAdheed/caseServices/CaseServices";
import Notaryservices from "../pages/notaryServices/Notaryservices";
import ConditionalComponent from "../pages/Footerpages/ConditionalComponent";
import PackagesMain from "../pages/packagespages/PackagesMain";
import UploadDocumentLatest from "../pages/UploadDocument/UploadDocumentLatest";
import Thankyou from "../pages/thankyou/Thankyou";
import PaymentLatest from "../pages/PaymentLatest/PaymentLatest";
import AccountProfile from "../components/accounts/AccountProfile/AccountProfile";
import MobileUpload from "../MobileUpload";
import Desktop from "../Desktop";
import Layout from "../layouts/Layout";
import { UploadModalProvider } from "../context/UploadModalContext";
import AccountSectionLayout from "../layouts/AccountSectionLayout";
import LayoutWithoutFooter from "../layouts/LayoutWithoutFooter";
import PaymentLayout from "../layouts/PaymentLayout";
import SimpleLayout from "../layouts/SimpleLayout";
import UploadLayout from "../layouts/UploadLayout";
import AccountLayout from "../pages/account/AccountLayout";
import OrderConfirmation from "../components/emailTemplates/OrderConfirmation";
import Applicants from "../components/Myorders/applicants/Applicants";
import AddressListing from "../components/accounts/AddressListing/AddressListing";

import AccountFaq from "../components/accounts/faqs/AccountFaq";

import MyOrders from "../components/Myorders/MyOrders";
import ApplicantsList from "../components/accounts/ApplicantsList/ApplicantsList";
import OrderDetails from "../components/Myorders/OrderDetails/OrderDetails";
import HomeNew from "../pages/home/HomeNew";
import DedCategoryList from "../pages/dedActivities/DedCategoryList";
import DedActivityDetail from "../pages/dedActivities/DedActivityDetail";
import DedActivityList from "../pages/dedActivities/DedActivityList";
import Dashboard from "../components/accounts/AccountDashboard/Dashboard";
import PreLoader from "../components/preloader/PreLoader";
import { Suspense } from "react";
import Registration from "../pages/Registration/Registration";
import ReviewIndex from "../pages/goodhandReview/ReviewIndex";
import ReviewList from "../pages/goodhandReview/ReviewList";

const MultiLangRouter = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "",
        element: (
          <Suspense fallback={<PreLoader />}>
            <HomeNew />
          </Suspense>
        ),
      },
      // { path: "", element: <HomeNew /> },
      { path: "Home-old", element: <Home /> },
      { path: "about", element: <ConditionalComponent /> },
      { path: "services/packages", element: <PackagesMain /> },
      { path: "services/:slug", element: <Services /> },
      { path: "blog", element: <Blog /> },
      { path: "blogDetails", element: <BlogDetails /> },
      { path: "termsandconditions", element: <TermsAndConditions /> },
      { path: "privacyandpolicy", element: <PrivacyAndPolicy /> },
      { path: "cancellationPolicy", element: <CancellationPolicy /> },
      { path: "contactus", element: <Contact /> },
      { path: "reviews", element: <ReviewPage /> },
      { path: "visa-packages-dubai", element: <Packages /> },
      {
        path: "legal-translation-services-in-dubai",
        element: <LegalTranslation />,
      },
      { path: "LegalTranslation-details", element: <LegalTranslationDetail /> },
      { path: "register", element: <Registration /> },
      { path: ":slugUrl", element: <ConditionalComponent /> },
      { path: ":category/:subCategory", element: <ConditionalComponent /> },
      {
        path: ":category/:subCategory/:slugUrl",
        element: <ConditionalComponent />,
      },

      { path: "dubai-courts-al-adheed", element: <Aladheed /> },
      { path: "dubai-economy/activities", element: <DedCategoryList /> },
      {
        path: "dubai-economy/activities/:activityUrl",
        element: <DedActivityList />,
      },
      {
        path: "dubai-economy/activities/:activityUrl/:activityCode",
        element: <DedActivityDetail />,
      },
      {
        path: "dubai-courts-al-adheed/marriage-service",
        element: <MarriageServices />,
      },
      {
        path: "dubai-courts-al-adheed/personal-case",
        element: <PesrsonalCases />,
      },
      {
        path: "dubai-courts-al-adheed/all-case-services",
        element: <CaseService />,
      },
      { path: "notary-services-dubai", element: <Notaryservices /> },
      { path: "new-flow-modal", element: <AfterGetQuote /> },
      { path: "dd", element: <Desktop /> },
      { path: "mobile-upload/:sessionId", element: <MobileUpload /> },
      { path: "notfound", element: <NotFound /> },
    ],
  },
  { path: "review/index", element: <ReviewIndex /> },
  { path: "review/view", element: <ReviewList /> },
  { path: "emailTemplate", element: <OrderConfirmation /> },

  { path: "accountOld", element: <AccountLayout /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AccountSectionLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: "accounts", element: <AccountProfile /> },
      { path: "accounts/Dashboard", element: <Dashboard /> },
      { path: "accounts/MyDocuments", element: <ApplicantsList /> },
      { path: "accounts/applicants", element: <Applicants /> },
      { path: "accounts/profile", element: <AccountProfile /> },
      { path: "accounts/address", element: <AddressListing /> },
      { path: "accounts/faqs", element: <AccountFaq /> },
      { path: "accounts/orders", element: <MyOrders /> },
      { path: "accounts/orderDetail", element: <OrderDetails /> },
    ],
  },

  {
    path: "/",
    element: <LayoutWithoutFooter />,
    children: [
      { path: "cart1", element: <Cart1 /> },
      {
        path: "checkout",
        element: (
          <ProtectedRoute>
            <CheckOut />
          </ProtectedRoute>
        ),
      },
      {
        path: "addresspage",
        element: (
          <ProtectedRoute>
            <AddressPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "addRemoveUpdataAddress",
        element: (
          <ProtectedRoute>
            <AddRemoveUpdataAddress />
          </ProtectedRoute>
        ),
      },
      {
        path: "orderlist/:slug",
        element: (
          <ProtectedRoute>
            <OrderList />
          </ProtectedRoute>
        ),
      },
      {
        path: "applicationdetail/:slug",
        element: (
          <ProtectedRoute>
            <OrderDetail />
          </ProtectedRoute>
        ),
      },
      {
        path: "orderflow",
        element: (
          <ProtectedRoute>
            <OrderFlow />
          </ProtectedRoute>
        ),
      },
      {
        path: "setting",
        element: (
          <ProtectedRoute>
            <SettingPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "newpayment",
        element: (
          <ProtectedRoute>
            <NewPayment />
          </ProtectedRoute>
        ),
      },
    ],
  },

  {
    path: "/",
    element: <SimpleLayout />,
    children: [{ path: "helpcenter", element: <HelpSection /> }],
  },

  {
    path: "/",
    element: <PaymentLayout />,
    children: [
      { path: "cart", element: <Cart1 /> },
      {
        path: "booking",
        element: (
          <ProtectedRoute>
            <Booking />
          </ProtectedRoute>
        ),
      },
      { path: "bookingdetail/:slug", element: <BookingDetail /> },
    ],
  },

  {
    path: "/",
    element: (
      <UploadModalProvider>
        <UploadLayout />
      </UploadModalProvider>
    ),
    children: [
      {
        path: "uploadocument",
        element: (
          <ProtectedRoute>
            <UploadDocumentLatest />
          </ProtectedRoute>
        ),
      },
      {
        path: "thankyou",
        element: (
          <ProtectedRoute>
            <Thankyou />
          </ProtectedRoute>
        ),
      },
      {
        path: "payment",
        element: (
          <ProtectedRoute>
            <PaymentLatest />
          </ProtectedRoute>
        ),
      },
      { path: "thank-you", element: <AfterGetQuote /> },
    ],
  },

  {
    path: "/CancelPayment",
    element: <Navigate to="/payment" replace />,
  },
];

export default MultiLangRouter;
